
/**
 * Created by nijin on 6/6/17.
 */
import {Component, ViewChild, Output, EventEmitter, OnInit, Input} from '@angular/core';
import {FormGroup, Validators, FormBuilder} from '@angular/forms';
import {GlobalValidator} from '../../../shared/validators/global-validator';
import {NotificationBarService} from '../../../core/notify/notification.service';
import {NotificationType} from '../../../core/notify/index';
import {ApiKeyService} from '../../api-key.service';
@Component({
  selector:'nuc-regenerate-key-confirmation',
  template: `
       <app-modal #popup>
  <div class="app-modal-header">
    <h3 class="modal-title">Regenerate API Key?</h3>
  </div>
  <div class="app-modal-body">
  <form [formGroup]="regenForm">
      <p>Regenerating the API key will disconnect all associated Things/Apps/<span class="hyphen">- </span>Controllers from the platform.</p>
    <p class="setActiveTime">Allow the existing API Key to be temporarily active for <span>
  
    <input type="number" class="form-control" placeholder="0" id="grace-period" 
           formControlName="gracePeriod" min="1" max="36" #grace>
    </span> hour(s).</p>
    <span class="error" id="grace-period-error">{{formErrors.gracePeriod | translate}}</span>
  </form>
  </div>
  <div class="app-modal-footer">
    <div class="btn-group-1 text-center">
      <button class="btn btn-secondary" (click)="close()"  id="regenerate-cancel" [disabled]="isLoading">
        {{'COMMON.CANCEL' | translate}}</button>
      <button class="btn btn-primary"  id="regenerate" (click)="regenerate(grace.value)" [disabled]="isLoading">
       <span *ngIf="isLoading"> <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> </span>
       {{ (isLoading ? 'API_KEY.REGENERATING':'API_KEY.REGENERATE') | translate}}
        </button>
    </div>
  </div> 
</app-modal>
 `,
  styleUrls: ['./popup.scss']

})
export class RegenerateKeyConfirmationComponent implements OnInit {

   isSubmitted = false;
   isLoading = false;
  @Input() apiKey: any;
  @ViewChild ('popup') popup;
  @Output() onAccept: EventEmitter<any> = new EventEmitter<any>();
  @Output() onReject: EventEmitter<number> = new EventEmitter<number>();
  formErrors = {
    'gracePeriod': ''
  };
  validationMessages = {
    'gracePeriod': {
      'required':  'API_KEY.REGEN_VALIDATIONS.REQUIRED',
      'invalidRange': 'API_KEY.REGEN_VALIDATIONS.RANGE',
      'integerValidation': 'API_KEY.REGEN_VALIDATIONS.INTEGER',
    }
  };

  regenForm: FormGroup;

  constructor(private fb: FormBuilder,
              private apiKeyFeature: ApiKeyService,
              private notifier: NotificationBarService) {

  }

  ngOnInit() {
    this.buildForm();
  }

  regenerate(hrs) {
    this.isSubmitted = true;
    this.onValueChanged();
    if (this.regenForm.valid) {
      const data = {
        timeToLive: (hrs * 60 * 60 * 1000) + new Date().getTime()
      };
      this.isLoading = true;
      this.apiKeyFeature.reGenerateApiKey(this.apiKey.id, data)
        .subscribe((response) => {
           this.isLoading = false;
           this.onAccept.emit(response.data);
           this.close();
           this.notifier.create({type: NotificationType.Success, message: response.status.message});
        },
          (error) => {
            this.isLoading = false;
            this.notifier.create({type: NotificationType.Error, message: error});
      });
    }
  }


  open() {
    this.regenForm.reset();
    this.formErrors['gracePeriod'] = '';
    this.popup.open();
  }

  close() {
    this.popup.hide();
  }
  buildForm() {
    this.regenForm = this.fb.group({
      'gracePeriod': ['', [
        Validators.required,
        GlobalValidator.numberBetween(1, 36),
        GlobalValidator.integerValidation,

      ]]
    });
    this.regenForm.valueChanges
      .subscribe(data => this.onValueChanged(data));
    this.onValueChanged();
  }
  onValueChanged(data?: any) {
    if (!this.regenForm) { return; }
    const form = this.regenForm;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && (control.dirty && !control.valid || this.isSubmitted)) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] = messages[key];
        }
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/accounts/api-key/modal/regenerate.key.confirmtaion.ts